import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ReferenceListEditor from './ReferenceListEditor';

const LIST_TYPES = [
  { value: 'customer', label: 'Customers' },
  { value: 'item', label: 'Items' },
  { value: 'class', label: 'Classes' },
  { value: 'location', label: 'Locations' },
];

export default function ReferenceListsPanel() {
  return (
    <div data-testid="reference-lists-panel">
      <Tabs defaultValue="customer" className="w-full">
        <TabsList data-testid="reference-list-type-tabs" className="w-full overflow-x-auto justify-start">
          {LIST_TYPES.map((t) => (
            <TabsTrigger key={t.value} value={t.value} data-testid={`reference-list-type-tab-${t.value}`}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {LIST_TYPES.map((t) => (
          <TabsContent key={t.value} value={t.value} className="mt-4">
            <ReferenceListEditor listType={t.value} label={t.label} />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
